module.exports = __webpack_public_path__ + "img/binovative-checkup-logo.aa95878f.png";